import { formatReportRatio } from '../helpers/reportRatio'
import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import DoNotDisturbOnOutlined from '@mui/icons-material/DoNotDisturbOnOutlined'
import { formatMoney } from '../../../helpers/utils'
import { buildActivityEffectivenessValues } from '../helpers/routeKpiValues'
import { formatLastActivity } from './reportMobileUserCardUtils'
import {
  formatPendingSettlementCount,
  formatPendingSettlementLabel,
  getPendingSettlementLabelColor
} from '../helpers/pendingSettlement'

const iconSize = { fontSize: 20 }

export function buildReportDeliveriesUserMobileCardSections(
  model,
  { isSingleDayRange = true } = {}
) {
  const effectiveness = buildActivityEffectivenessValues(model, 'delivery').effectiveness
  const userName = model.user_name ?? '—'
  const visited = model.total_visited_in_route_clients ?? 0
  const attended = model.total_in_route_clients ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.last_visit)
  const pendingLabel = formatPendingSettlementLabel(model.settlement_status, isSingleDayRange)
  const pendingColor = getPendingSettlementLabelColor(pendingLabel)
  const pendingDeliveriesCount = String(
    formatPendingSettlementCount(model.pending_deliveries_settlement_count, isSingleDayRange)
  )

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const docs = `${model.delivery_documents_closed_count ?? 0}/${model.delivery_documents_total_count ?? 0}`
  const geo = formatReportRatio(model.geofence_activities_count, model.total_activities_count)

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(model.out_of_route_clients ?? 0),
      boldValue: true,
      valueTitle: String(model.out_of_route_clients ?? 0)
    },
    {
      icon: <DescriptionOutlined sx={iconSize} />,
      label: 'Documentos entregados',
      value: docs,
      boldValue: true,
      valueTitle: docs
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad visita/entregas',
      value: `${Math.round(effectiveness)}%`,
      boldValue: true,
      valueTitle: `${Math.round(effectiveness)}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <DoNotDisturbOnOutlined sx={iconSize} />,
      label: 'Total rechazos',
      value: formatMoney(model.total_delivery_rejected),
      boldValue: true,
      valueTitle: formatMoney(model.total_delivery_rejected)
    },
    {
      icon: <PendingActionsOutlined sx={iconSize} />,
      label: 'Estado de liquidación',
      value: pendingLabel,
      boldValue: true,
      valueTitle: pendingLabel,
      valueSx: { color: pendingColor }
    },
    {
      icon: <PendingActionsOutlined sx={iconSize} />,
      label: 'Entregas pendientes por liquidar',
      value: pendingDeliveriesCount,
      boldValue: true,
      valueTitle: pendingDeliveriesCount
    },
    {
      icon: <LocalShippingOutlined sx={iconSize} />,
      label: 'Total entregas',
      value: formatMoney(model.total_delivery),
      boldValue: true,
      valueTitle: formatMoney(model.total_delivery)
    }
  ]

  return { summaryRows, detailRows }
}
